<template>
  <div
    class="panel relative z-[calc(var(--z-nav)+1)] box-border flex w-(--left-rail-width) shrink-0 flex-col items-center gap-3
           border-r border-line pb-6.25
           before:pointer-events-none before:absolute before:inset-0 before:-z-1 before:bg-chrome before:content-['']
           before:[backdrop-filter:var(--glass-blur)] before:[-webkit-backdrop-filter:var(--glass-blur)]
           max-sm:order-2 max-sm:z-(--z-nav) max-sm:h-(--mobile-nav-height) max-sm:w-full max-sm:flex-row-reverse
           max-sm:items-center max-sm:justify-between max-sm:gap-0 max-sm:border-t max-sm:border-r-0
           max-sm:py-0 max-sm:before:bg-popover-solid max-sm:[&_.userAvatar]:size-6!"
    :class="(navOpened || openedDialog === 'UserSheet') && 'max-sm:z-[calc(var(--z-nav)+1)]!'"
  >
    <div
      class="header-burger flex h-12 w-full items-center justify-center overflow-hidden border-b border-line
             [-webkit-app-region:no-drag]
             max-sm:order-10 max-sm:h-auto max-sm:w-[20vw] max-sm:shrink-0
             max-sm:overflow-visible max-sm:border-b-0 [.browser-safari_&]:overflow-visible"
    >
      <Navbar
        target='el-proj'
        type='list'
        ref='projectList'
        class="project-navigation"
        :disabled="loadingProject"
        @open="closeUserMenu"
        @update:opened="navOpened = $event"
      >
        <template #wrapper>
          <div
            class="nav-button-burgr flex size-10 items-center justify-center rounded-control
                   transition-[background,color] duration-150 hover:bg-hover hover:text-accent
                   max-sm:h-16 max-sm:w-[20vw] max-sm:flex-col max-sm:gap-1 max-sm:transition-none
                   max-sm:hover:bg-transparent max-sm:[&_svg]:size-6!"
            :class="navOpened ? 'text-accent' : 'text-text max-sm:hover:text-text!'"
          >
            <IconBars3 class="burger-icon block size-6" />
            <span class="mobile-nav-label">{{ $t('menu.nav_menu') }}</span>
          </div>
        </template>
        <template #items>
          <ProjectsNavigation
            ref='projectNav'
          />
        </template>
      </Navbar>
    </div>
    <div
      class="buttons center-area flex flex-col justify-center gap-3 sm:relative sm:grow
             max-sm:grow-0 max-sm:flex-row max-sm:gap-0"
    >
      <div class="relative max-sm:flex max-sm:w-[20vw] max-sm:justify-center">
        <SimpleButton
          v-if="accessTrackingBrowser"
          :title="unhandledMentions ? `${ $t('menu.mentions_notify_1') } ${unhandledMentions} ${ $t(unhandledMentions > 1 ? 'menu.mentions_notify_2_multy' : 'menu.mentions_notify_2_single') }`: ''"
          variant="ghost"
          class="header-button my-tasks flex! size-17 flex-col justify-center gap-0.75 text-center
                 rounded-tile! border! border-line! bg-input! text-text! shadow-none!
                 hover:border-accent! hover:bg-accent-soft! hover:text-accent!
                 [&.pressed]:border-accent! [&.pressed]:bg-accent-soft! [&.pressed]:text-accent!
                 max-sm:h-16! max-sm:w-full! max-sm:min-h-0! max-sm:gap-1! max-sm:border-0! max-sm:px-0!
                 max-sm:bg-transparent! max-sm:hover:bg-transparent! max-sm:[&.pressed]:bg-transparent!
                 max-sm:[&_svg]:mb-0! max-sm:[&_svg]:size-6!"
          :pressed="$route.name === 'myTasks' && !(mobileMode && (navOpened || openedDialog))"
          :to="{
            name: $route.name === 'myTasks' ? 'project': 'myTasks',
            params: {
              projectSlug: project.slug || 'last',
              slugNameProject: project.nameSlug || 'Last Project',
            },
          }"
        >
            <!-- the phone nav uses outline icons, like the burger and the bell next to it -->
            <IconSquares2x216Solid class="text-xl mb-1 max-sm:hidden"/>
            <IconClipboardDocumentList class="hidden max-sm:block"/>
            <div class="label text-label font-bold leading-none max-sm:hidden">My tasks</div>
            <span class="mobile-nav-label">{{ $t('menu.nav_tasks') }}</span>
        </SimpleButton>
        <div
          v-if="unhandledMentions"
          class="notification-bulb absolute right-0 bottom-0
                 max-sm:top-3 max-sm:right-[calc(50%-1rem)] max-sm:bottom-auto"
        ></div>
      </div>

      <div class="create-task__wrapper relative max-sm:flex max-sm:w-[20vw] max-sm:items-center max-sm:justify-center">
        <SimpleButton
          variant="green"
          class="header-button create-task-button create-task relative flex! size-17 flex-col justify-center gap-0.75
                 text-center rounded-tile! text-on-green!
                 shadow-[var(--green-glow)]! hover:brightness-108!
                 max-sm:size-12! max-sm:bg-accent! max-sm:text-on-accent!
                 max-sm:shadow-none! max-sm:[&_svg]:mb-0! max-sm:[&_svg]:size-6!"
          data-no-create-click-outside
          @click="() => visibleCreateTask(!showCreateTask)"
          @shortkey="() => visibleCreateTask(!showCreateTask)  "
          :title="$t('ui.common_header_create_task_title')"
        >
          <IconPlus class="hidden max-sm:block"/>
          <svg class="add-icon size-5.5 max-sm:hidden" viewBox="0 0 17 17" aria-hidden="true">
            <g stroke="currentColor" stroke-width="2" stroke-linecap="round">
              <line x1="8.5" y1="3" x2="8.5" y2="14" />
              <line x1="3" y1="8.5" x2="14" y2="8.5" />
            </g>
          </svg>
          <div class="label create-task text-label font-bold leading-none max-sm:hidden">Add</div>
        </SimpleButton>
        <Teleport to="body">
          <div
            class="create-task__popup fixed inset-0 flex items-center justify-center max-sm:z-1"
            v-if="showCreateTask"
          >
            <CreateTask
              :stageId="createTaskStageId"
              @close="visibleCreateTask(false)"
              @open="visibleCreateTask(true)"
            />
          </div>
        </Teleport>
      </div>
      <TrackButton
        :activeTrackingTask="activeTrackingTask"
        :taskUnderEdit="taskUnderEdit"
        @stop="stopTracking($event)"
        @start="startTracking($event)"
      />
      <AiChat v-if="showAiChat" @close="showAiChat = false" />
      <RecordingControls
        v-if="screenRecordingActive"
        :paused="screenRecordingPaused"
        @toggle-pause="toggleScreenRecordingPause"
        @stop="stopScreenRecording"
      />
    </div>

    <!-- on phones Header teleports its notifications bell and profile menu here, at the right end of the nav
         (the nav runs row-reverse, so -order-1 is the rightmost slot) -->
    <div
      id="mobile-nav-account"
      class="hidden max-sm:-order-1 max-sm:flex max-sm:items-center"
    ></div>

    <div
      class="buttons login-area flex flex-col justify-center gap-3
             max-sm:hidden"
    >
      <div v-if="!isApp()" class="download-app__wrapper max-sm:hidden">
          <SimpleButton
            class="header-button download-app flex! size-17 flex-col justify-center gap-0.75 text-center
                   rounded-tile! border! border-line! bg-input! text-text! shadow-none!
                   hover:border-accent! hover:bg-accent-soft! hover:text-accent!
                   [&.pressed]:border-accent! [&.pressed]:bg-accent-soft! [&.pressed]:text-accent!
                   max-sm:size-10! max-sm:border-0! max-sm:bg-transparent! max-sm:text-[1.875rem]!
                   max-sm:[&_svg]:mb-0! max-sm:[&_svg]:size-9! max-sm:[&_svg]:text-text!"
            @click="openDownloadAppPage()"
          >
            <IconInboxArrowDown16Solid class="text-xl mb-1"/>
            <div class="label text-label font-bold leading-none max-sm:hidden">Get app</div>
          </SimpleButton>
      </div>
    </div>
  </div>
</template>

<!-- <script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      maximized: false,
      hideForDrag: false,
      activeUpdating: false,
      showHeaderActionButtons: false,
    };
  },
  computed: {
    ...mapState('project', ['taskUnderEdit']),
  },
};
</script> -->

<script setup>
import { ref, computed, onMounted, onBeforeMount, getCurrentInstance, watch, nextTick } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import CreateTask from '@/components/widgets/CreateTask';
import eventBus from '@/eventBus';
import { pauseRecording, resumeRecording, stopRecording } from '@/utils/screenRecorder';
import ProjectsNavigation from '@/components/widgets/ProjectsNavigation';
import Navbar from '@/components/elements/Navbar';
import TrackButton from '@/components/elements/TrackButton';
import RecordingControls from '@/components/elements/RecordingControls';
import { useI18n } from 'vue-i18n';
import { useMagicKeys } from '@vueuse/core'
import SimpleButton from './elements/SimpleButton.vue';
import AiChat from '@/components/widgets/AiChat.vue';
import {
  IconBars3, IconClipboardDocumentList, IconInboxArrowDown16Solid, IconPlus, IconSquares2x216Solid,
} from '@iconify-prerendered/vue-heroicons';
// (duplicate eventBus import removed)

const { proxy } = getCurrentInstance();

const keys = useMagicKeys();

watch(keys['alt+n'], (pressed) => {
  if (pressed) {
    showCreateTask.value = true;
  }
});


const store = useStore();
const router = useRouter();
const route = useRoute();
const { t } = useI18n();

const showCreateTask = ref(false);
const showAiChat = ref(false);
// Use global store state for recording activity
const screenRecordingActive = computed(() => store.state.system.recordingActive);
const screenRecordingPaused = computed(() => store.state.system.recordingPaused);

const accessTrackingBrowser = computed(() => store.getters['user/accessTrackingBrowser']);
const unhandledMentions = computed(() => store.state.user.unhandledMentions);
const activeTrackingTask = computed(() => store.state.task.activeTrackingTask);
const project = computed(() => store.state.project.project);
const taskUnderEdit = computed(() => store.state.project.taskUnderEdit);
const openedDialog = computed(() => store.state.system.openedDialog);
const mobileMode = computed(() => store.state.system.mobileMode);

const loadingProject = computed(() => {
  return !(router.currentRoute.value.name !== 'project' || (project.value && project.value.name));
});

function stopTracking(event) {
  store.dispatch('task/stopTracking', event);
}
function startTracking(event) {
  store.dispatch('task/startTracking', event);
}
function closeUserMenu() {
  eventBus.$emit('close-user-menu');
}

function isActive(name) {
  return router.currentRoute.value.name === name;
}
function isApp() {
  return window.APP_TRON;
}
function openDownloadAppPage() {
  router.push({ name: 'getApp' });
}


const isOpenedForSubtask = ref(false);
// the burger shows it's pressed while the side menu is open
const navOpened = ref(false);
const createTaskStageId = ref(null);

function visibleCreateTask(flag, parentTaskId) {
  console.log('👁️ 👁️visibleCreateTask', flag, parentTaskId);
  showCreateTask.value = flag;
  isOpenedForSubtask.value = !!parentTaskId;
  if (!flag) createTaskStageId.value = null;
  store.commit('system/setOpenedDialog', flag ? 'CreateTask' : null);
}
// Stop screen recording flow: ensure original task is loaded before firing stop
async function ensureRecordingTaskLoaded() {
  try {
    const rec = window.trackliRec;
    if (!rec || !rec.recordingTaskId) return;
    // If taskUnderEdit already the one - done
    if (taskUnderEdit.value && taskUnderEdit.value.id === rec.recordingTaskId) return;
    // Navigate to stored route if available
    if (rec.recordingTaskRoute && router.currentRoute.value.fullPath !== rec.recordingTaskRoute) {
      await router.push(rec.recordingTaskRoute);
    }
    // Wait until store sets taskUnderEdit
    const maxWait = 10_000; // 4s
    const start = Date.now();
    await new Promise((resolve) => {
      const int = setInterval(() => {
        if ((taskUnderEdit.value && taskUnderEdit.value.id === rec.recordingTaskId) || Date.now() - start > maxWait) {
          clearInterval(int);
          resolve();
        }
      }, 100);
    });
  } catch (e) { 
    console.error('Error ensuring recording task is loaded', e);
  }
}
// Centralized stop handler moved from RecordingPopup
async function stopRecordingHandler() {
  await stopRecording();
  store.commit('system/setRecordingActive', false);
  store.commit('system/setRecordingPaused', false);
}

function toggleScreenRecordingPause() {
  if (screenRecordingPaused.value) {
    resumeRecording();
  } else {
    pauseRecording();
  }
  store.commit('system/setRecordingPaused', !screenRecordingPaused.value);
}

async function stopScreenRecording() {
  await ensureRecordingTaskLoaded();
  if (screenRecordingActive.value) {
    await stopRecordingHandler();
  } else {
    // fallback legacy event - ask popup to stop if still open
    eventBus.$emit('screen-recording-stop');
  }
}

// New event to explicitly request stop from anywhere
eventBus.$on('callStopRecordingHandler', async () => {
  await ensureRecordingTaskLoaded();
  if (screenRecordingActive.value) await stopRecordingHandler();
});

// Backward compatibility
eventBus.$on('screen-recording-stop', async () => {
  if (screenRecordingActive.value) await stopRecordingHandler();
});
onMounted(() => {
  eventBus.$off('open-ai-chat');
  eventBus.$on('open-ai-chat', () => { showAiChat.value = !showAiChat.value; });
});
onBeforeMount(() => {
  eventBus.$on('open-create-task', (stageId) => {
    createTaskStageId.value = stageId || null;
    visibleCreateTask(true);
  });
  eventBus.$on('open-create-task_from', async (data) => {
    visibleCreateTask(true);
    await nextTick();
    eventBus.$emit('create-task-painterro', data);
  });
  eventBus.$on('toggle-create-subtask', async (parentTaskId) => {
    console.log('🤲 toggle-create-subtask', {
      parentTaskId, 
      showCreateTask:showCreateTask.value,
      isOpenedForSubtask: isOpenedForSubtask.value,
    });
    if (showCreateTask.value && (!!parentTaskId === !!isOpenedForSubtask.value)) {
      visibleCreateTask(false);
      return;
    }
    visibleCreateTask(true, parentTaskId);
    await nextTick();
    eventBus.$emit('create-task-set-parent', parentTaskId);
  });
});
</script>
